export default "__VITE_PUBLIC_ASSET__8c235ef8__"